import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "reduce",
  "use": "reduce-usage",
  "viewBox": "0 0 146 146",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 146 146\" id=\"reduce\"><style>#reduce .st0{fill-rule:evenodd;clip-rule:evenodd}</style><path class=\"st0\" d=\"M73 0C32.7 0 0 32.7 0 73s32.7 73 73 73 73-32.7 73-73S113.3 0 73 0zm0 136.9c-35.3 0-63.9-28.6-63.9-63.9S37.7 9.1 73 9.1s63.9 28.6 63.9 63.9-28.6 63.9-63.9 63.9z\" /><path class=\"st0\" d=\"M119.5 79.6h-93c-3.7 0-6.6-3-6.6-6.6 0-3.7 3-6.6 6.6-6.6h92.9c3.7 0 6.6 3 6.6 6.6.1 3.7-2.9 6.6-6.5 6.6z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/reduce.svg
// module id = bjWj
// module chunks = 6